import React, { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CBadge,
  CButton,
  CInputGroup,
  CFormInput
} from '@coreui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import CIcon from '@coreui/icons-react';
import { cilSearch, cilTrash, cilFindInPage } from '@coreui/icons';

const AdminCarpools = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [carpools, setCarpools] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  const loadCarpools = async () => {
    setLoading(true);
    try {
      const response = await adminAPI.getCarpools({ search: searchTerm });
      setCarpools(response.data.carpools || []);
    } catch (error) {
      console.error('Failed to load carpools:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      loadCarpools();
    }, 300);
    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  return (
    <div className="admin-carpools">
      <CCard>
        <CCardHeader className="d-flex justify-content-between align-items-center">
          <h2 className="admin-page-title mb-0">{t('admin.carpools') || 'Carpools'}</h2>
          <CInputGroup style={{ width: '300px' }}>
            <CFormInput
              placeholder={t('common.search') || 'Search...'}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <CButton type="button" color="secondary">
              <CIcon icon={cilSearch} />
            </CButton>
          </CInputGroup>
        </CCardHeader>
        <CCardBody>
          <CTable align="middle" className="mb-0 border" hover responsive>
            <CTableHead color="light">
              <CTableRow>
                <CTableHeaderCell>{t('carpools.name')}</CTableHeaderCell>
                <CTableHeaderCell>{t('carpools.activity')}</CTableHeaderCell>
                <CTableHeaderCell>{t('carpools.address')}</CTableHeaderCell>
                <CTableHeaderCell>{t('carpools.members')}</CTableHeaderCell>
                <CTableHeaderCell>{t('admin.rides')}</CTableHeaderCell>
                <CTableHeaderCell>{t('admin.actions')}</CTableHeaderCell>
              </CTableRow>
            </CTableHead>
            <CTableBody>
              {carpools.map((carpool) => (
                <CTableRow key={carpool.id}>
                  <CTableDataCell>
                    <div className="fw-bold">{carpool.name}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <CBadge color="info">{carpool.activity}</CBadge>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{carpool.address}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{carpool.membersCount}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <div>{carpool.ridesCount}</div>
                  </CTableDataCell>
                  <CTableDataCell>
                    <CButton 
                      color="primary" 
                      variant="outline" 
                      size="sm" 
                      className="me-2"
                      onClick={() => navigate(`/carpools/${carpool.id}`)}
                    >
                      <CIcon icon={cilFindInPage} />
                    </CButton>
                    <CButton color="danger" variant="outline" size="sm">
                      <CIcon icon={cilTrash} />
                    </CButton>
                  </CTableDataCell>
                </CTableRow>
              ))}
            </CTableBody>
          </CTable>
          
          {carpools.length === 0 && (
            <div className="text-center py-5">
              <p className="text-muted">{t('admin.noCarpools') || 'No carpools found'}</p>
            </div>
          )}
        </CCardBody>
      </CCard>
    </div>
  );
};

export default AdminCarpools;

